import { getCookie, setCookie } from "@/utils/cookies";
import { createClientOnlyFn, createServerOnlyFn } from "@tanstack/react-start";
import ms from "ms";

export const cookieName = "tz";
const ttl = ms("1y");
export const getServerTimezone = createServerOnlyFn(() => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
});
export const getClientTimezone = createServerOnlyFn(async () => {
  return await getCookie(cookieName);
});

export const setClientTimezone = createClientOnlyFn((timezone: string) => {
  setCookie(cookieName, timezone, {
    expires: ttl,
  });
});
